import { ModuleLink as Link } from '../../../components/ModuleLink';
import { fmtDate } from '../../../utils';
import type { ChangeRequest } from '../../../types';

interface Props { record: ChangeRequest; cid: string; onRefresh: () => Promise<void>; }

export default function ClosedSection({ record, cid }: Props) {
  return (
    <div className="section-panel">
      <div className="section-panel__header">
        <h2 className="section-panel__title"><i className="fa-solid fa-circle-check" aria-hidden="true" /> Change Closed</h2>
      </div>
      <div className="section-panel__body">
        <div className="alert alert--success" style={{ marginBottom: 24 }}>
          <span className="alert__icon"><i className="fa-solid fa-circle-check" aria-hidden="true" /></span>
          <div className="alert__body">
            <div className="alert__title">This change has been formally closed.</div>
            <p>All steps have been completed and the Sponsor has confirmed closure.</p>
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <div className="field-display"><div className="field-display__label">Change ID</div><div className="field-display__value change-id-mono">{record.changeId}</div></div>
          <div className="field-display"><div className="field-display__label">Change Name</div><div className="field-display__value">{record.changeName}</div></div>
          <div className="field-display"><div className="field-display__label">Closure Date</div><div className="field-display__value">{fmtDate(record.closureDate)}</div></div>
          <div className="field-display"><div className="field-display__label">Sponsor Sign-Off</div><div className="field-display__value">{fmtDate(record.sponsorSignoffDate)}</div></div>
          <div className="field-display"><div className="field-display__label">Survey Status</div><div className="field-display__value">{record.surveyStatus ?? '—'}</div></div>
          <div className="field-display"><div className="field-display__label">Average Score</div><div className="field-display__value">{record.surveyScore != null ? `${record.surveyScore} / 10` : '—'}</div></div>
        </div>
        <div style={{ marginTop: 24 }}>
          <Link to={`/change-detail?cid=${encodeURIComponent(cid)}`} className="btn btn--secondary">
            <i className="fa-solid fa-eye" aria-hidden="true" /> View Full Record
          </Link>
        </div>
      </div>
    </div>
  );
}
